// Remembers where the user was headed before we bounced them to /login, so we
// can send them back after sign-in. Uses sessionStorage because the Google OAuth
// flow is a full-page redirect away and back — in-memory state wouldn't survive.
const RETURN_TO_KEY = 'valoi-return-to';

// A safe in-app destination: a single leading slash NOT followed by another
// slash or a backslash. Rejects protocol-relative ('//host', and '/\host' which
// browsers normalize to '//host') and absolute ('http(s)://') targets, so a
// stored value can never be used to redirect off-site after sign-in.
const isSafeInAppPath = (path: string | null): path is string =>
  !!path && /^\/(?![/\\])/.test(path);

export function saveReturnTo(path: string) {
  if (typeof window === 'undefined') return;
  // Only store safe in-app destinations; ignore the auth routes themselves.
  if (!isSafeInAppPath(path) || path.startsWith('/login') || path.startsWith('/auth/callback')) {
    return;
  }
  try {
    window.sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    // Non-blocking; falling back to '/' on read is fine.
  }
}

// Reads and clears the stored destination, defaulting to the home page at '/'.
export function takeReturnTo(): string {
  if (typeof window === 'undefined') return '/';
  try {
    const path = window.sessionStorage.getItem(RETURN_TO_KEY);
    window.sessionStorage.removeItem(RETURN_TO_KEY);
    return isSafeInAppPath(path) ? path : '/';
  } catch {
    return '/';
  }
}
